import { createSlice } from '@reduxjs/toolkit';
import { athkarMudafa} from './allAthkar';
import { numDecreaseAct, prograssNum, showInfoAct } from './actions';



const athkarMudafaSlice = createSlice({
  name: 'athkarMudafa',
  initialState: athkarMudafa,
  reducers: {
    showInfoSL: showInfoAct,
    numDecreaseMD: numDecreaseAct,
    prograssNumMD:prograssNum
  },
});

export const { showInfoMD, numDecreaseMD,prograssNumMD } = athkarMudafaSlice.actions;
export default athkarMudafaSlice.reducer;